<cz-numeric-display [num]="displayedPrice" [zeros]="trailingZeros"></cz-numeric-display>
